<template>
  <div class="clazz_header" @click="gotoClazz">
    <img class="cover" :src="clazz.cover_url">
    <div class="info">
      <div class="title">{{ clazz.clazz_name }}</div>
      <!-- <div class="intro">{{ clazz.user_num }}人已参加</div> -->
      <div class="leader">参与时间：{{ clazz.start_time_format2 }} ～ {{ clazz.end_time_format2 }}</div>
      <div class="leader">跑步天数：{{ clazz.run_days }}天 | 每天距离：{{ clazz.day_distance }}公里</div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant'

export default {
  name: 'ClazzHeader',
  components: {
    [Icon.name]: Icon
  },
  props: {
    clazz: {
      type: Object
    },
    isLeader: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    gotoClazz () {
      this.$router.push('/clazz/' + this.clazz.uuid)
    }
  }
}
</script>

<style scoped lang="scss">
.clazz_header {
  width: 700px;
  // background-color: #333a46;
  color: #fff;
  // padding: 15px 0 15px 15px;
  // border-radius: 10px;
  display: flex;
  align-items: center;
  .cover {
    width: 140px;
    height: 140px;
    object-fit: cover;
  }
  .info {
    width: 500px;
    height: 140px;
    display: flex;
    margin-left: 20px;
    flex-direction: column;
    justify-content: space-around;
    .title {
      font-size: 28px;
      font-weight: bold;
      color: #fff;
    }
    .intro, .leader {
      font-size: 24px;
      color: #bbb;
    }
    .actions {
      display: flex;
      .btn {
        font-size: 22px;
        margin-right: 15px;
        border-radius: 4px;
        background-color: #fff;
        color: #323233;
      }
      .share {
        padding: 2px 20px;
      }
      .more {
        padding: 2px 5px;
        font-weight: bold;
      }
    }
  }
  // .icon {
  //   font-size: 28px;
  // }
}
</style>
